import PropTypes from 'prop-types';
import { Component } from 'react';
import styles from './message-modal.module.less';
import { formatNumber, pluralize } from '../../utils/index';

class MessagesContainer extends Component {
    componentDidMount() {
        this.node.scrollTop = this.node.scrollHeight;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.messagesAndTransactions.length < this.props.messagesAndTransactions.length || this.props.error) {
            this.node.scrollTop = this.node.scrollHeight;
        }
    }

    render() {
        const messagesAndTransactions = this.props.messagesAndTransactions ? (
            <div>
                {this.props.messagesAndTransactions.map((activity, key) => {
                    if (activity.type === 'message') {
                        return (
                            <p
                                key={key}
                                className={
                                    activity.sender_id === this.props.userId
                                        ? styles.messageSent
                                        : styles.messageReceived
                                }
                            >
                                {activity.body}
                            </p>
                        );
                    }

                    const userSentMessage = activity.from_user === this.props.userId;
                    const rewardText =
                        activity.rewards?.length > 0
                            ? `for ${pluralize(
                                  activity.rewards.length,
                                  'belønningen',
                                  'belønningene'
                              )} ${activity.rewards.join(', ')}`
                            : '';
                    let transactionMessage = userSentMessage
                        ? `Du ga ${formatNumber(activity.amount)} kr`
                        : `Ga deg ${formatNumber(activity.amount)} kr`;
                    transactionMessage = rewardText ? `${transactionMessage} ${rewardText}` : transactionMessage;

                    return (
                        <p key={key} className={userSentMessage ? styles.transactionSent : styles.transactionReceived}>
                            {transactionMessage} 💰
                        </p>
                    );
                })}
            </div>
        ) : null;

        return (
            <div
                ref={(node) => {
                    this.node = node;
                }}
                className={styles.messageContainer}
            >
                <div className={styles.messageInfo}>
                    <i className={`${styles.messageInfoIcon} fa-solid fa-lightbulb`} aria-hidden="true" />
                    <div className={styles.messageInfoMessage}>
                        Mottakeren blir varslet om henvendelsen din, men Spleis kan ikke garantere for svar. Du blir
                        varslet på e-post når du har fått svar på henvendelsen.
                    </div>
                </div>
                {messagesAndTransactions}
                {this.props.error && this.props.error.global ? (
                    <p className={styles.messageSendError}>{this.props.error.global}</p>
                ) : null}
            </div>
        );
    }
}

MessagesContainer.propTypes = {
    messagesAndTransactions: PropTypes.array,
    userId: PropTypes.number,
    error: PropTypes.object,
};

export default MessagesContainer;
